/**
 * One-shot, in-memory hand-off for the plaintext Aadhaar typed in the ABHA creation flow, so it can
 * pre-fill the register form without riding in router state. react-router persists navigation
 * state into window.history.state, which the browser writes to disk, outside the app's own logout
 * purge. Module memory dies with the tab and is cleared on first read.
 */
let pending = null;

export function stashTransientAadhaar(value) {
  if (typeof value === 'string' && /^\d{12}$/.test(value)) pending = value;
}

export function takeTransientAadhaar() {
  const value = pending;
  pending = null;
  return value;
}
